import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FuelTruckMeterDetails from './FuelTruckMeterDetails';

class FuelTruckGroupDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupTotal: 0,
    };

    this.calculateTotal = this.calculateTotal.bind(this);
  }

  componentWillMount() {
    this.calculateTotal();
  }

  calculateTotal() {
    let total = 0;
    const meters = this.props.truck.fuelTanks[0].fuelMeters;
    meters.forEach((meter) => {
      meter.fuelOrders.forEach((fuelOrder) => {
        total += fuelOrder.totalQuantityAdded;
      });
    });

    this.setState({ groupTotal: total });
  }
  renderTotal() {
    return (
      <div className="group-total right">
        <hr />
        <strong>{this.props.truck.name} Total: {parseFloat(this.state.groupTotal).toFixed(1)} Gal</strong>
      </div>
    );
  }

  renderMeters() {
    const meters = this.props.truck.fuelTanks[0].fuelMeters;

    return meters.map(meter =>
      <FuelTruckMeterDetails key={meter.id} fuelMeter={meter} />);
  }

  renderOrderGroupHeadings() {
    return (
      <div className="report-item-headings">
        <div className="report-col-truck">Aircraft</div>
        <div className="report-col-plane-type">School</div>
        <div className="report-col-plane-type">Other</div>
        <div className="report-col-truck">Begin Meter</div>
        <div className="report-col-truck">End Meter</div>
        <div className="report-col-truck">Total Fuel</div>
        <div className="report-col-truck">Time</div>
        <div className="report-col-truck">Initial</div>
        <div className="report-col-truck">Invoice #</div>
        <div className="clear" />
      </div>
    );
  }

  render() {
    return (
      <span>
        <h4> {this.props.truck.name} </h4>
        {this.renderOrderGroupHeadings()}
        <article className="order-item">
          {this.renderMeters()}
          {this.renderTotal()}
        </article>
      </span>
    );
  }
}

FuelTruckGroupDetails.propTypes = {
  truck: PropTypes.shape({}).isRequired,
};

export default FuelTruckGroupDetails;



// WEBPACK FOOTER //
// ./src/Containers/Reports/FuelTrucks/FuelTruckGroupDetails.js